// Config
var RBX_SWATCH_DEBUG = true;   // set false to silence logs
var RBX_VISIBLE_ONLY = true;   // only consider visible inputs when finding "first in group"

function rlog(){ if (RBX_SWATCH_DEBUG) try { console.log.apply(console, arguments); } catch(e){} }

/**
 * Click checked product swatches ONLY (radios inside product-card / quick-buy-modal),
 * in reverse order, skipping the first radio in its local group, and without scrolling.
 */
function clickSwatchesReverse(root) {
  if (!root) root = document;
  rlog("▶ clickSwatchesReverse: root =", root);

  // 1) Start with checked radios INSIDE product areas only
  var radios = jQuery(
    "product-card input[type='radio']:checked, quick-buy-modal input[type='radio']:checked",
    root
  );

  // 2) Extra safety: exclude anything inside facets (drawer/sidebar/filter forms)
  radios = radios.filter(function () {
    return !jQuery(this).closest('facets-drawer, .facets-sidebar, form.facets').length;
  });

  // 3) Reverse order
  var list = radios.get().reverse();
  rlog("• product checked radios (post-filter):", list.length, list);

  jQuery.each(list, function (i, el) {
    var $in = jQuery(el);

    console.groupCollapsed && console.groupCollapsed("▸ swatch[" + i + "]", {
      id: $in.attr("id"),
      name: $in.attr("name"),
      card: $in.closest('product-card, quick-buy-modal')[0]
    });

    if ($in.data("swatchFired")) { rlog("  — skip: already fired"); console.groupEnd && console.groupEnd(); return; }
    $in.data("swatchFired", true);

    var name = $in.attr("name");
    if (!name) { rlog("  — skip: no name"); console.groupEnd && console.groupEnd(); return; }

    // 4) Scope the group to the nearest product container (NOT the whole page)
    var $container = $in.closest('product-card, quick-buy-modal');
    if (!$container.length) { rlog("  — skip: no product container"); console.groupEnd && console.groupEnd(); return; }

    var $groupAll = jQuery("input[name='" + name.replace(/'/g, "\\'") + "']", $container);
    var $group = RBX_VISIBLE_ONLY ? $groupAll.filter(":visible") : $groupAll;

    rlog("  group in container — all:", $groupAll.length, "visible:", $group.length);

    var first = $group.first()[0];
    var idxAll = $groupAll.index(el), idxVis = $group.index(el);
    rlog("  index (all):", idxAll, "index (visible):", idxVis, "first:", first);

    // 5) Skip if this checked input is the first in its local group
    if (el === first) { rlog("  — skip: is first in local group"); console.groupEnd && console.groupEnd(); return; }

    // 6) Find the label swatch and trigger without scroll jump
    var id = $in.attr("id");
    var $label = id ? jQuery("label[for='" + id.replace(/'/g, "\\'") + "']", $container) : $in.next("label");
    rlog("  label found?", !!($label && $label.length), $label && $label[0]);

    var x = window.scrollX, y = window.scrollY; // remember scroll

    try {
      if ($label && $label.length) {
        $label.trigger("mouseenter").trigger("mousedown").trigger("click").trigger("mouseup");
        $in.trigger("change");
        rlog("  ✓ label events + change dispatched");
      } else {
        $in.trigger("click").trigger("change");
        rlog("  ✓ input click + change dispatched (no label)");
      }
    } catch (e) {
      rlog("  ✗ ERROR dispatching:", e);
    }

    window.scrollTo(x, y); // restore scroll
    console.groupEnd && console.groupEnd();
  });

  rlog("◀ clickSwatchesReverse: done");
}

// Re-run when product cards/modals are injected (filtering, quick buy, etc.)
var mo = new MutationObserver(function (muts) {
  jQuery.each(muts, function (_, m) {
    jQuery(m.addedNodes).each(function () {
      if (this.nodeType === 1) {
        // Only react if product areas were added
        if (this.matches?.("product-card, quick-buy-modal, .product-list") ||
            jQuery(this).find("product-card, quick-buy-modal, .product-list").length) {
            setTimeout(function () {
              clickSwatchesReverse();
            }, 100); // delay in ms
        }
      }
    });
  });
});
mo.observe(document.documentElement, { childList: true, subtree: true });


// Run after DOM ready (and again on load)
jQuery(document).ready(function () {
  setTimeout(function () {
    clickSwatchesReverse();
  }, 300); // delay in ms
});
